import React from "react";
import "../../Assets/Styles/pages/cancel_button.scss";
import moment from "moment";
import { useTranslation } from "react-i18next";

const BlogsTile = ({ item }) => {
  const { t } = useTranslation();

  return (
    <div
      style={{ height: "20rem" }}
      className=" d-flex flex-column flex-lg-row justify-content-center m-3 blogsTileImage "
    >
      <div className="d-flex justify-content-center">
        <img
          alt={item.title}
          className="w-100 img-fluid blogsTileImageSrc bg_blogsTile border_blogsTile_image"
          src={item.feature_image}
        />
      </div>
      <div className="w_45 blogsTileImageSrc d-flex flex-column justify-content-between p-4 bg_blogsTile border_blogsTile">
        <div>
          <div className="mb-3 productSans text_16 text_brown">
            {moment(item.published_at).format("DD-MM-YYYY")}
          </div>
          <div className="mb-3 productSansBold text_19 text-black">
            {item.title}
          </div>
          <div className="size_blog_summary productSansLight text_14 text-black">
            {item.excerpt +
              " " +
              item.excerpt +
              " " +
              item.excerpt +
              " " +
              item.excerpt}
          </div>
        </div>
        <div>
          <div
            onClick={() => {
              window.location.href = `blog.ezywatermark.com/${item.slug}`;
            }}
            className=" productSans pointer text_18 landing_banner_Heading"
          >
            {t("ContinueReading")}
          </div>
        </div>
      </div>
    </div>
  );
};
export default BlogsTile;
